import { Button } from '../components';
import ChatDefaultCircle from '../icon/chat_default_circle';

interface WebChatSignInDialogProps {
	onSignIn: () => void;
	onContinueAnonymous: () => void;
}

export default function WebChatSignInDialog({
	onSignIn,
	onContinueAnonymous,
}: WebChatSignInDialogProps) {
	return (
		<div className="w-full flex flex-col gap-100 bg-neutral-100 border border-neutral-300 px-300 py-250 shadow-[0_0_10px_0_rgba(0,0,0,0.20)]">
			<div className="flex items-center self-start gap-2">
				<ChatDefaultCircle width={24} height={24} />
				<h2 className="font-sans text-xs tracking-[3px] font-bold uppercase">Chat with us</h2>
			</div>
			<p className="font-serif text-sm leading-250 tracking-[0.5px]">
				Sign in to connect with a team member – available anytime, anywhere to perfect your travel
				experience.
			</p>
			<div className="flex flex-col items-start md:flex-row gap-150 mt-100">
				<Button intent={'filled'} onClick={onSignIn} className="rounded-none !h-300 md:!h-10">
					Sign in / Register
				</Button>
				<Button
					intent={'outline'}
					onClick={onContinueAnonymous}
					className="rounded-none !h-300 md:!h-10"
				>
					No, thanks
				</Button>
			</div>
		</div>
	);
}
